import TraitsContext from "contexts/TraitsContext";
import { useContext } from "react";

const useTraits = () => useContext(TraitsContext);

export default useTraits;
